import { useResourceParams } from '@refinedev/core';
import { useDocumentTitle as useDocTitle } from '@refinedev/react-router';

interface useDocumentTitleProps {
  resourceTitle: string;
  listTitle?: string;
  showTitle?: string;
  editTitle?: string;
  createTitle?: string;
}

/**
 * Hook encargado de generar el titulo de la pagina.
 * Para referenciar al id en el titulo especificado se debe indicar {id} donde se desea
 * @param props
 * @param props.resourceTitle: nombre del recurso (tickets, envios, recepciones, etc);
 * @param props.listTitle?: titulo para el listado;
 * @param props.showTitle?: titulo para la visualización;
 * @param props.editTitle?: titulo para la edición;
 * @param props.createTitle?: titulo para la creación;
 */
const useDocumentTitle = (props: useDocumentTitleProps) => {
  const { resourceTitle, listTitle, editTitle, showTitle, createTitle } = props;
  const { action, id } = useResourceParams();
  const title =
    action === 'edit' && editTitle
      ? editTitle.replace('{id}', id as string)
      : action === 'show' && showTitle
        ? showTitle.replace('{id}', id as string)
        : action === 'create' && createTitle
          ? createTitle
          : action === 'list' && listTitle
            ? listTitle
            : 'Acronex';

  useDocTitle(id ? `${title} | Acronex` : `${resourceTitle} | ${title}`);

  return { id };
};

export default useDocumentTitle;
